var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.02101 5.09895C4.27085 4.78665 4.72654 4.73602 5.03883 4.98586L7.00026 6.555L8.96169 4.98586C9.27398 4.73602 9.72968 4.78665 9.97951 5.09895C10.2293 5.41124 10.1787 5.86694 9.86642 6.11677L7.00026 8.4097L4.1341 6.11677C3.82181 5.86694 3.77118 5.41124 4.02101 5.09895Z",
    fill: "#6150AC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.724138 5.79297C1.12407 5.79297 1.44828 6.11718 1.44828 6.51711V10.6206H12.5517V6.51711C12.5517 6.11718 12.8759 5.79297 13.2759 5.79297C13.6758 5.79297 14 6.11718 14 6.51711V12.0688H0V6.51711C0 6.11718 0.324208 5.79297 0.724138 5.79297Z",
    fill: "#6150AC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99953 0C7.39946 0 7.72367 0.324208 7.72367 0.724138V7.48276C7.72367 7.88269 7.39946 8.2069 6.99953 8.2069C6.5996 8.2069 6.27539 7.88269 6.27539 7.48276V0.724138C6.27539 0.324208 6.5996 0 6.99953 0Z",
    fill: "#6150AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.5517246014dca638ac143aa407077ef3.svg";
export { ForwardRef as ReactComponent };